import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tnt-security',
  templateUrl: './security.component.html',
  host: { 'style': 'width: 100%' },
})
export class TntSecurityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
